(function() {
  var root = document.getElementById('DispatchTimeline');
  if (!root) return;

  var cutoffHour = parseInt(root.dataset.cutoffHour) || 14;
  var skipRaw = (root.dataset.skipDates || '').split(',').map(function(d) { return d.trim(); }).filter(Boolean);

  function q(sel) { return root.querySelector(sel); }
  var orderText    = q('[data-text="order"]');
  var dispatchText = q('[data-detail="dispatch"]');
  var deliveredText= q('[data-detail="delivered"]');
  var pulse        = q('[data-pulse]');
  var steps        = { order: q('[data-step="order"]'), dispatch: q('[data-step="dispatch"]'), delivered: q('[data-step="delivered"]') };
  var connectors   = { c1: q('[data-connector="1"]'), c2: q('[data-connector="2"]') };

  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var days   = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  function isWeekend(d) { var day = d.getDay(); return day === 0 || day === 6; }
  function isSkip(d) {
    var yyyy = d.getFullYear();
    var mm = String(d.getMonth()+1).padStart(2,'0');
    var dd = String(d.getDate()).padStart(2,'0');
    return skipRaw.indexOf(mm+'-'+dd) !== -1 || skipRaw.indexOf(yyyy+'-'+mm+'-'+dd) !== -1;
  }
  function canDispatch(d) { return !isWeekend(d) && !isSkip(d); }

  function nextWorkDay(from) {
    var d = new Date(from); d.setDate(d.getDate()+1);
    while (!canDispatch(d)) d.setDate(d.getDate()+1);
    return d;
  }
  function nextDelivery(from) {
    var d = new Date(from); d.setDate(d.getDate()+1);
    while (isWeekend(d) || isSkip(d)) d.setDate(d.getDate()+1);
    return d;
  }

  function sameDay(a, b) { return a.getDate()===b.getDate() && a.getMonth()===b.getMonth() && a.getFullYear()===b.getFullYear(); }
  function friendly(d) {
    var now = new Date();
    if (sameDay(d, now)) return 'Today';
    var tom = new Date(now); tom.setDate(tom.getDate()+1);
    if (sameDay(d, tom)) return 'Tomorrow';
    return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()];
  }

  function setState(el, state) {
    if (!el) return;
    el.className = el.className.replace(/dispatch-timeline__(step|connector)--(active|completed|future)/g, '');
    var base = el.dataset.step ? 'dispatch-timeline__step--' : 'dispatch-timeline__connector--';
    el.classList.add(base + state);
  }

  function update() {
    if (!document.body.contains(root)) { clearInterval(intervalId); return; }
    var now = new Date();
    var todayDispatches = canDispatch(now);
    var beforeCutoff = now.getHours() < cutoffHour;

    if (todayDispatches && beforeCutoff) {
      var cutoff = new Date(now); cutoff.setHours(cutoffHour,0,0,0);
      var diff = cutoff - now;
      var h = Math.floor(diff/3600000);
      var m = Math.floor((diff%3600000)/60000);
      var delivery = nextDelivery(now);

      if (orderText) orderText.innerHTML = '<strong>' + h + 'h ' + m + 'm</strong> left';
      if (dispatchText) dispatchText.textContent = 'Today';
      if (deliveredText) deliveredText.textContent = friendly(delivery);
      if (pulse) pulse.style.display = '';
      root.classList.add('dispatch-timeline--urgent');
      root.classList.remove('dispatch-timeline--relaxed');

      setState(steps.order, 'active');
      setState(steps.dispatch, 'active');
      setState(steps.delivered, 'future');
      setState(connectors.c1, 'active');
      setState(connectors.c2, 'future');

    } else {
      var nextDisp = nextWorkDay(now);
      var delivery = nextDelivery(nextDisp);

      if (orderText) orderText.textContent = 'Now';
      if (dispatchText) dispatchText.textContent = friendly(nextDisp);
      if (deliveredText) deliveredText.textContent = friendly(delivery);
      if (pulse) pulse.style.display = 'none';
      root.classList.remove('dispatch-timeline--urgent');
      root.classList.add('dispatch-timeline--relaxed');

      setState(steps.order, 'completed');
      setState(steps.dispatch, 'future');
      setState(steps.delivered, 'future');
      setState(connectors.c1, 'future');
      setState(connectors.c2, 'future');
    }
  }

  update();
  var intervalId = setInterval(update, 60000);
})();
